import React, { useMemo } from 'react';
import { Typography } from '@mui/material';
import appInfo from '../../../package.json'
import { StyledFooter } from '../../constants/styledComponents';

const Footer = () => {
  // using useMemo to memoize the current year
  const currentYear = useMemo(() => new Date().getFullYear(), []);

  return (
    <StyledFooter>
      <Typography variant="body1" color="textSecondary">
        © {currentYear} {appInfo.companyName}
      </Typography>
    </StyledFooter>
  );
};

export default Footer;
